import { render, staticRenderFns } from "./PostgreSQL.vue?vue&type=template&id=17436c61"
import script from "./PostgreSQL.vue?vue&type=script&lang=js"
export * from "./PostgreSQL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports